import { createApp, ref } from 'vue'
import './style.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router/index.js'
import rem from './method/rem.js'
import ls from './method/localStorage.js'
import { GetLanguagePack } from './model/language.js'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App);

// 创建响应式的屏幕尺寸
const clientWidth = ref(document.documentElement.clientWidth);
const clientHeight = ref(document.documentElement.clientHeight);
// 实际可用视口高度（用于移动设备工具栏适配）
const viewportHeight = ref(document.documentElement.clientHeight);


const isPortrait = ref(window.matchMedia('(orientation: portrait)').matches);
const isMobile = () => {
    // 基础的移动设备UA检测
    const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // 检查屏幕方向
    const isPortrait = window.matchMedia('(orientation: portrait)').matches

    // 补充检测：根据屏幕方向检查屏幕尺寸
    // 竖屏时检查宽度，横屏时检查高度
    let isSmallScreen = false;
    if (isPortrait) {
        isSmallScreen = window.innerWidth < 768;
    } else {
        isSmallScreen = window.innerHeight < 768;
    }

    // 结合UA和屏幕尺寸判断
    // 注意：iPad在某些情况下可能会被识别为桌面设备，但我们仍然希望它在竖屏下显示
    const isTablet = /iPad/i.test(navigator.userAgent);

    // 控制台输出当前设备信息，帮助调试
    console.log('设备UA检测结果:', mobileUA);
    console.log('屏幕方向 - 竖屏:', isPortrait);
    console.log('屏幕宽度:', window.innerWidth);
    console.log('屏幕高度:', window.innerHeight);
    console.log('是否为小屏幕:', isSmallScreen);
    console.log('是否为iPad:', isTablet);

    // 仅在移动设备或小屏幕上应用竖屏限制
    return (mobileUA && isSmallScreen) || isTablet;
};
const isMobileDevice = ref(isMobile());

// 更新实际可用视口高度
function updateViewportHeight() {
    // 对于支持visualViewport的设备，使用visualViewport.height
    if (window.visualViewport) {
        viewportHeight.value = window.visualViewport.height;
    } else {
        // 回退方案
        viewportHeight.value = document.documentElement.clientHeight;
    }
    
    if (isMobileDevice.value) {
        // 检测是否是软键盘弹出导致的视口高度变化
        const isKeyboardEvent = window.innerHeight > viewportHeight.value && 
                               Math.abs(window.innerHeight - viewportHeight.value) > 100;
        
        // 只有在非软键盘弹出状态时才更新--vh变量
        if (!isKeyboardEvent ) {
            console.log(viewportHeight.value)
            // 更新CSS变量
            const vh = viewportHeight.value * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
    }
}

// 页面加载时立即更新视口高度
updateViewportHeight();

// 添加窗口大小变化监听
window.addEventListener('resize', () => {
    // 所有设备都根据屏幕尺寸更新尺寸信息
    clientWidth.value = document.documentElement.clientWidth;
    clientHeight.value = document.documentElement.clientHeight;
    // 更新屏幕方向
    isPortrait.value = window.matchMedia('(orientation: portrait)').matches;
    // 更新实际可用视口高度
    updateViewportHeight();
});


app.use(rem)
app.use(router)
app.use(ElementPlus)

//注册图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

//添加屏幕宽和高的全局变量
app.config.globalProperties.clientWidth = clientWidth;
app.config.globalProperties.clientHeight = clientHeight;
app.config.globalProperties.isMobileDevice = isMobileDevice;
app.config.globalProperties.isPortrait = isPortrait;
app.config.globalProperties.LangPack = GetLanguagePack(ls.get("lang"));
app.config.globalProperties.tabname = '1';

app.mount('#app')
